import { render } from "./detailUsers.vue?vue&type=template&id=cb512d78&scoped=true"
import script from "./detailUsers.vue?vue&type=script&lang=js"
export * from "./detailUsers.vue?vue&type=script&lang=js"

import "./detailUsers.vue?vue&type=style&index=0&id=cb512d78&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb512d78"]])

export default __exports__